<ng-container *ngIf="progressState$ | async as progressState">
  <mat-dialog-content class="text-center max-h-fit p-4 overflow-hidden">
    <!-- Loading State -->
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mt-2"
      *ngIf="currentProgress.totalProgress < 100 && !error">
      <img src="../../../../assets/img/upload-document.gif" alt="Processing...">
    </div>

    <!-- Success State -->
    <div class="mx-auto flex items-center justify-center h-[50px] w-[50px] rounded-full bg-green-400 mt-2"
      *ngIf="currentProgress.totalProgress >= 100 && !error">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
        class="h-[45px] w-[45px] text-white">
        <path fill-rule="evenodd"
          d="M16.403 12.652a3 3 0 0 0 0-5.304 3 3 0 0 0-3.75-3.751 3 3 0 0 0-5.305 0 3 3 0 0 0-3.751 3.75 3 3 0 0 0 0 5.305 3 3 0 0 0 3.75 3.751 3 3 0 0 0 5.305 0 3 3 0 0 0 3.751-3.75Zm-2.546-4.46a.75.75 0 0 0-1.214-.883l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
          clip-rule="evenodd" />
      </svg>
    </div>

    <!-- Error State -->
    <div class="mx-auto flex items-center justify-center h-[50px] w-[50px] rounded-full bg-red-400 mt-2" *ngIf="error">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
        class="h-[45px] w-[45px] text-white">
        <path fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
          clip-rule="evenodd" />
      </svg>
    </div>

    <!-- Message -->
    <h3 class="text-md font-medium mt-3 mb-4" *ngIf="currentProgress.totalProgress >= 100 && !error">
      {{data.completedMessage}}</h3>
    <h3 class="text-md font-medium mt-3" *ngIf="currentProgress.totalProgress < 100 && !error">{{message}}</h3>
    <h3 class="text-md font-medium mt-3 text-red-600" *ngIf="error">{{message}}</h3>

    <!-- Warning Message -->
    <div class="mt-2" *ngIf="currentProgress.totalProgress < 100 && !error">
      <span class="text-red-500 text-sm">Please do not close this window.</span>
    </div>

    <!-- Progress Bar -->
    <div class="mt-2 w-full bg-gray-200 rounded overflow-hidden" *ngIf="!error">
      <div class="text-xs leading-none py-1 text-center text-white h-[25px]"
        [style.width]="currentProgress.totalProgress + '%'" [ngClass]="{
          'bg-green-500': currentProgress.totalProgress >= 100,
          'bg-blue-500 bg-stripes': currentProgress.totalProgress < 100
        }">
      </div>
    </div>

    <!-- Progress Text -->
    <div class="text-white text-sm flex flex-row justify-center w-full capitalize -mt-[22px]" *ngIf="!error">
      {{ currentProgress.totalProgress >= 100 ? 'Completed' : currentProgress.completedTasks + '/' +
      currentProgress.totalTasks + ' Tasks Complete' }}
    </div>

    <!-- Close Button -->
    <div class="mt-6" *ngIf="(currentProgress.totalProgress >= 100 || error) && data.showCloseButton">
      <button mat-raised-button color="primary" (click)="closeDialog()"
        class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">
        {{ data.closeButtonText || 'Close' }}
      </button>
    </div>
  </mat-dialog-content>
</ng-container>